// Facts the page shows that depend on the business, not on the design.
// Fill the empty values before publishing; empty values are hidden, never
// invented. After editing, run `node build.mjs`.
export const SITE = {
  name: 'Tickerback',
  appUrl: 'https://app.tickerback.com',
  // The public Journal (a separate site on the same domain); tools/blog.py
  // copies its latest articles into the blog block.
  blogUrl: 'https://tickerback.com/blog/',

  // Legal identity (the lawyer completes it; see lib/features/legal/domain/legal_documents.dart)
  company: {
    legalName: '', // razón social completa
    taxId: '', // NIF/CIF
    address: '', // domicilio social
  },
  contactEmail: 'support@tickerback.com', // public support or sales address
  // Address of the Enterprise "Talk to sales" button; falls back to
  // contactEmail. While both are empty the button stays visible but inactive.
  salesEmail: 'sales@tickerback.com',

  // Publish the free launch while live billing is still being prepared.
  paidPlansOpen: false,

  // Mobile apps are not in the stores yet; while false the page says the
  // app runs in the browser and the native apps are in preparation.
  storeAppsPublished: false,

  // A public share link of a real strategy (Mi estrategia → Compartir →
  // Enlace público). While empty, the hero's second button leads to
  // "Cómo funciona" instead of the example.
  // Public link created on 26/09/2026 from the PATROL test account (Pro):
  // one AAPL 215 call bought on 9 Aug 2024, opening on 29 Aug (+$700) and
  // navigable to the 20 Sep 2024 expiry (tools/demo_strategy.mjs).
  demoStrategyUrl: 'https://app.tickerback.com/#/shared-strategy?token=1514261748015ba9d94d7f606820e2b6da4728db7433b49d',
};
